import React, { Component, Fragment } from 'react';
import Slider from 'react-slick';

import testimonialImg1 from 'images/testimonials-img1.png';
import testimonialImg2 from 'images/testimonials-img2.png';
import testimonialImg3 from 'images/testimonials-img3.png';

const TESTIMONIALS_INFO = [
  {
    photo: testimonialImg1,
    name: 'Delia Maxwell',
    position: 'Professional photographer',
    text:
      '<p>With the popularity of social media, getting customer testimonials is extremely convenient.<p/><p> All you have to do is pull link on Facebook post or Twitter update, and you have instant proof that your customers love your products.</p>',
    id: '1',
  },
  {
    photo: testimonialImg2,
    name: 'Paul Williams',
    position: 'Professional producer',
    text:
      '<p>InstaLinks helps me to spread my creations faster. And now I can get feedback from websites and social networks, that I needed.</p>',
    id: '2',
  },
  {
    photo: testimonialImg3,
    name: 'Robert Tucker',
    position: 'Professional blogger',
    text:
      '<p>I know firsthand how it is important to stay in touch with your followers in all social networks. Just have to share my InstaLinks link.</p>',
    id: '3',
  },
];

const SlideTestimonial = ({ name, position, text, photo }) => {
  return (
    <div className="testimonials-itm">
      <div className="testimonials-itm__top">
        <div className="testimonials-itm__img">
          <img src={photo} alt="" />
        </div>
        <div className="testimonials-itm__member">
          <div className="testimonials-itm__name">{name} </div>
          <div className="testimonials-itm__position">{position}</div>
        </div>
      </div>
      <div className="separator-line white" />
      <div className="testimonials-itm__descr">
        <div
          className="testimonials-itm__text"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </div>
  );
};

class Testimonials extends Component {
  render() {
    var settings = {
      dots: true,
      infinite: true,
      arrows: false,
      speed: 1200,
      autoplaySpeed: 2500,
      slidesToShow: 1,
      autoplay: true,
      focusOnSelect: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      slidesToScroll: 1,
    };

    return (
      <Fragment>
        <div className="testimonials">
          <div className="h2-title big center white">Testimonials</div>
          <div className="testimonials__content">
            <div className="testimonials-slider">
              <Slider {...settings}>
                {TESTIMONIALS_INFO.map(testimonialSlide => (
                  <SlideTestimonial
                    key={testimonialSlide.id}
                    name={testimonialSlide.name}
                    position={testimonialSlide.position}
                    text={testimonialSlide.text}
                    photo={testimonialSlide.photo}
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/Testimonials/Testimonials.js